// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import { withRouter } from 'react-router-dom'
import { Query } from 'react-apollo'

import {
  Card,
  Grid,
  Spinner,
  Warning,
  EmployeeStats
} from '../../components'

import { decodeBase64 } from '../../utils'

import { QUERY_EMPLOYERGROUP_EMPLOYERS } from '../../queries'


const EmployerGroupEmployeeOverview = (props) => (
  <div
    className='slds-grid slds-size_1-of-1'
    style={{
      flexDirection: 'column',
      alignItems: 'center',
      height: 'calc(100vh - 80px)'
    }}>
    <div className='slds-size_1-of-2 slds-m-top_x-large'>
      <Card
        title={
          <div className='slds-text-color_weak' style={{ textAlign: 'center' }}>
            Group overview
          </div>
        }
        body={
          <EmployeeStats
            employerGroupId={props.match.params.employerGroupId}
            className='slds-p-bottom_medium'
            key={`employergroup_stats_${props.match.params.employerGroupId}`}
          />

        }
        style={{
          borderRadius: '5px',
          border: '1px solid rgba(90, 86, 251, 0.25)',
          boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.35)'
        }}
      />
    </div>
    <div className='slds-size_1-of-1 slds-m-top_large u-font-size-smaller'>
      <Query
        query={QUERY_EMPLOYERGROUP_EMPLOYERS}
        variables={{ employerGroupId: decodeBase64(props.match.params.employerGroupId) }}>
        {({ loading, error, data }) => {
          if (loading) {
            return <Spinner size='small' className='slds-is-relative' />
          }

          if (error) {
            return <Warning>Failed to fetch required subsidiary data</Warning>
          }

          return (
            <Grid
              items={data.employers.edges.map(({ node: employer }) => (
                <Card
                  title={
                    <div className='slds-text-color_weak u-font-size-smaller' style={{ textAlign: 'center' }}>
                      {employer.friendlyName}
                    </div>
                  }
                  body={
                    <EmployeeStats
                      employerId={employer.id}
                      className='slds-p-bottom_medium'
                      key={`employer_stats_${employer.id}`}
                    />

                  }
                  style={{
                    borderRadius: '5px',
                    border: '1px solid rgba(90, 86, 251, 0.25)',
                    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.35)'
                  }}
                  key={`subsidiary_${employer.id}`}
                />
              ))}
              evenlySpaceOutColumns={true}
              itemSpacing='medium'
              itemClassName='slds-p-left_small slds-p-right_small slds-p-bottom_large'
              className='slds-p-left_small slds-p-right_small'
            />
          )
        }}
      </Query>
    </div>
  </div>
)

export default withRouter(EmployerGroupEmployeeOverview)



// WEBPACK FOOTER //
// ./src/containers/messageplus/EmployerGroupEmployeeOverview.js